import * as types from '../constants/ActionTypes'

import 'whatwg-fetch';

const server = window.server || "";

//滚动区域高度
export const setScrollHeight = height =>{
	return {type:types.SET_SCROLL_HEIGHT,data:height}
}



// WEBPACK FOOTER //
// ./project/actions/util.js